module.exports = __webpack_public_path__ + "static/SectionFive-ba870bbe101816e1104bee41cf299f58.png";